import { Component, Input } from '@angular/core';

@Component({
  selector: "ngx-importacao-info",
  templateUrl: "./info.component.html",
  styleUrls: ["./info.component.scss"],
})
export class ImportacaoInfoComponent {
  @Input() fileName: string;
  @Input() titleTotalCarga: string = "Total carga";
  @Input() totalColaboradores: number;
  @Input() valorTotal: number;
}
